import { getWindowData } from "owa-window-data";

// Checks if the current environment is a hosted calendar based on the URL path.
// This util allows for paths that contain routing hints, e.g. /hosted/PUID@TID/calendar
export function isHostedCalendar(): boolean {
    const windowData = getWindowData();
    const pathSegments = windowData?.location?.pathname
        .split("/")
        .filter(segment => segment.length > 0);
    
    if (pathSegments.length > 2 && pathSegments[0] === "hosted" && pathSegments[2] === "calendar") {
        return true;
    }
    else if (pathSegments.length > 1 &&
        pathSegments[0] === "hosted" &&
        pathSegments[1] === "calendar") {
        return true;
    }
    else {
        return false;
    }
}
